// extracted by mini-css-extract-plugin
module.exports = {"storyCampaign":"ReadMore_storyCampaign__Xe_hf","text":"ReadMore_text__1SOV0","collapsible":"ReadMore_collapsible__2iDiv"};